<template>
  <textarea
    rows="4"
    class="custom-control"
    :class="{
      'is-valid': valid,
    }"
    :value="modelValue"
    @input="$emit('update:modelValue', $event.target.value)"
  />
</template>

<style scoped lang="css">
.custom-control {
  width: 100%;
}
</style>

<script>
export default {
  name: "Textarea",
  emits: ["update:modelValue"],
  props: {
    valid: {
      type: Boolean,
      default: false,
    },
    modelValue: {
      type: String,
    },
  },
  computed: {
    value: {
      get() {
        return this.modelValue;
      },

      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
};
</script>
